import {
  queryWithAuth,
  gql,
  queryWithoutAuth,
} from '@crystal-eyes/utils/apis/graphqlApi'
import getAuth from '@crystal-eyes/data/getAuth'
import { Assessments } from '@crystal-eyes/types'
import DataTags from '@crystal-eyes/data/dataTags'

const FETCH_OPTS = { next: { tags: [DataTags.UserData, DataTags.Assessments] } }

export default async function getAssessments({
  identity,
}: {
  identity: { id: string }
}): Promise<Assessments | undefined> {
  const auth = await getAuth()

  if (auth.authToken) {
    return queryWithAuth(
      auth,
      ASSESSMENTS_QUERY,
      {
        id: identity.id,
      },
      FETCH_OPTS,
    ).then(resp => resp.identity?.rootSnapshot?.assessments)
  } else {
    return queryWithoutAuth(
      PUBLIC_ASSESSMENTS_QUERY,
      {
        id: identity.id,
      },
      FETCH_OPTS,
    ).then(resp => resp.public.identity?.rootSnapshot?.assessments)
  }
}

const ASSESSMENTS_QUERY = gql`
  query getAssessments($id: Guid!) {
    identity(id: $id) {
      rootSnapshot {
        assessments {
          disc {
            takenAt
          }

          bigFive {
            extraversion
            agreeableness
            conscientiousness
            emotionalStability
            openness
          }

          enneagram {
            description
            name
            number
          }

          mbti {
            description
            traits {
              between
              leansTowards
            }
            type
          }

          strengths {
            traits {
              name
              description
            }
          }

          values {
            traits {
              name
              description
            }
          }
        }
      }
    }
  }
`

const PUBLIC_ASSESSMENTS_QUERY = gql`
  query public_getAssessments($id: Guid!) {
    public {
      identity(id: $id) {
        rootSnapshot {
          assessments {
            disc {
              takenAt
            }

            bigFive {
              extraversion
              agreeableness
              conscientiousness
              emotionalStability
              openness
            }

            enneagram {
              description
              name
              number
            }

            mbti {
              description
              traits {
                between
                leansTowards
              }
              type
            }

            strengths {
              traits {
                name
                description
              }
            }

            values {
              traits {
                name
                description
              }
            }
          }
        }
      }
    }
  }
`
